const SETTINGS_BASE = "/api/v1/settings";

/* ---------- Search Defaults ---------- */

export interface SaveSearchDefaultsPayload {
  search_top_k?: number;
  candidate_pool_multiplier?: number;
  quality_retrieval_boost?: number;
  search_query_weight?: number;
  search_quality_weight?: number;
  linkedin_quality_company_weight?: number;
  github_bonus_weight?: number;
  github_only_quality_cap?: number;
  company_tier_weights?: Record<string, number>;
  school_tier_weights?: Record<string, number>;
  company_history_decay?: [number, number, number];
  school_history_decay?: [number, number, number];
  company_age_decay?: [number, number, number];
  company_unranked_weight?: number;
  school_unranked_weight?: number;
}

export interface SaveSearchDefaultsResponse {
  saved: boolean;
  pipeline_triggered: boolean;
  cache_cleared: number;
}

export interface PipelineStatus {
  status: "idle" | "running" | "completed" | "failed";
  message: string;
  elapsed_seconds?: number;
}

export async function saveSearchDefaults(
  payload: SaveSearchDefaultsPayload
): Promise<SaveSearchDefaultsResponse> {
  const res = await fetch(`${SETTINGS_BASE}/search-defaults`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const err = await res.text().catch(() => "Unknown error");
    throw new Error(`Failed to save search defaults: ${err}`);
  }
  return res.json();
}

export async function resetSearchDefaults(): Promise<SaveSearchDefaultsResponse> {
  const res = await fetch(`${SETTINGS_BASE}/search-defaults`, {
    method: "DELETE",
    credentials: "include",
  });
  if (!res.ok) {
    const err = await res.text().catch(() => "Unknown error");
    throw new Error(`Failed to reset search defaults: ${err}`);
  }
  return res.json();
}

export async function getPipelineStatus(): Promise<PipelineStatus> {
  const res = await fetch(`${SETTINGS_BASE}/search-defaults/pipeline-status`, {
    credentials: "include",
  });
  if (!res.ok) throw new Error("Failed to fetch pipeline status");
  return res.json();
}
